<template>
  <div class="composite-chart-section">
    <CommonTitleUnderline :title="title" :chips="chips" />
    <slot />
  </div>
</template>

<script setup lang="ts">
import CommonTitleUnderline from '../common/CommonTitleUnderline.vue'

defineProps<{
  title: string
  chips?: { title: string, backgroundColor: string }[]
}>()
</script>

<style scoped>
.composite-chart-section {
  display: flex;
  flex-direction: column;
}
</style>
